(function () {
  if (window.__pwReturnsOfferBooted) return;
  window.__pwReturnsOfferBooted = true;

  function qs(root, sel) { return root.querySelector(sel); }

  function safeJsonParse(txt) {
    try { return JSON.parse(txt || '{}'); } catch (e) { return {}; }
  }

  function formatMoneyFromCents(cents) {
    if (cents == null) return '';
    var n = Number(cents) / 100;
    var ccy = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'GBP';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: ccy }).format(n);
    } catch (e) {
      return '£' + n.toFixed(2);
    }
  }

  function percentOff(fullCents, gradedCents) {
    var a = Number(fullCents || 0);
    var b = Number(gradedCents || 0);
    if (!a || !b || b >= a) return '';
    return Math.round(((a - b) / a) * 100) + '%';
  }

  async function addItemsToCart(items) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items || [] })
    });
    if (!res.ok) throw new Error('Add failed');
    return res.json();
  }

  function openCartDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:change'));

    var trigger =
      document.querySelector('[data-drawer-id="cart-drawer"]') ||
      document.querySelector('[aria-controls="cart-drawer"]');

    if (trigger) trigger.click();
  }

  var states = new WeakMap();

  function getState(root) {
    return states.get(root);
  }

  function getSelectedVariantId(root, form) {
    var visibleSelect = qs(root, '.pw-variant-select');
    if (visibleSelect && visibleSelect.value) return String(visibleSelect.value);

    var checkedId = qs(root, 'input[name="id"]:checked');
    if (checkedId && checkedId.value) return String(checkedId.value);

    var idInput = qs(form, 'input[name="id"]');
    return idInput ? String(idInput.value || '') : '';
  }

  function getSelectedSku(root, form, skuMap) {
    var id = getSelectedVariantId(root, form);
    var sku = id ? (skuMap[id] || '') : '';
    return String(sku || '').trim();
  }

  function getCaseChoice(form) {
    var checked = qs(form, 'input[name="pw_set_choice"]:checked');
    return checked ? checked.value : 'only';
  }

  function getCaseVariantId(form) {
    return form.dataset.caseVariantId ? String(form.dataset.caseVariantId) : '';
  }

  function buildNewItems(root, form) {
    var items = [];
    var mainVariantId = getSelectedVariantId(root, form);
    if (mainVariantId) items.push({ id: Number(mainVariantId), quantity: 1 });

    if (getCaseChoice(form) === 'case') {
      var caseVariantId = getCaseVariantId(form);
      if (caseVariantId) items.push({ id: Number(caseVariantId), quantity: 1 });
    }

    return items;
  }

  function buildGradedItems(root, form, gradedVariantId) {
    var items = [];
    if (gradedVariantId) items.push({ id: Number(gradedVariantId), quantity: 1 });

    if (getCaseChoice(form) === 'case') {
      var caseVariantId = getCaseVariantId(form);
      if (caseVariantId) items.push({ id: Number(caseVariantId), quantity: 1 });
    }

    return items;
  }

  async function fetchProductJson(handle) {
    if (!handle) return null;
    var res = await fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) return null;
    return await res.json();
  }

  function findVariantBySku(productJson, sku) {
    if (!productJson || !productJson.variants || !sku) return null;
    return productJson.variants.find(function (v) {
      return String(v.sku || '').trim() === sku && v.available;
    }) || null;
  }

  function openModal(modal) {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function setOffersLayout(offersWrap, count) {
    if (!offersWrap) return;
    if (count >= 2) offersWrap.classList.add('pw-two-col');
    else offersWrap.classList.remove('pw-two-col');
  }

  function bestOffer(offers) {
    var a = offers.find(function (o) { return o.grade === 'A'; });
    if (a) return a;
    var b = offers.find(function (o) { return o.grade === 'B'; });
    return b || null;
  }

  async function getFullPriceCents(state) {
    var selectedId = getSelectedVariantId(state.root, state.form);
    var currentHandle = state.cfg.currentHandle || '';
    if (!currentHandle) return 0;

    var currentJson = await fetchProductJson(currentHandle);
    if (!currentJson || !currentJson.variants) return 0;

    var n = Number(selectedId);
    var v = currentJson.variants.find(function (x) {
      return Number(x.id) === n;
    }) || null;

    return v ? Number(v.price || 0) : 0;
  }

  async function checkOfferAll(state) {
    var baseSku = getSelectedSku(state.root, state.form, state.skuMap);
    if (!baseSku) return [];

    var gradeAHandle = state.cfg.gradeAHandle || '';
    var gradeBHandle = state.cfg.gradeBHandle || '';

    // Your current SKU rule
    var skuA = baseSku + '-RA';
    var skuB = baseSku + '-RB';

    var results = await Promise.all([
      gradeAHandle ? fetchProductJson(gradeAHandle) : Promise.resolve(null),
      gradeBHandle ? fetchProductJson(gradeBHandle) : Promise.resolve(null)
    ]);

    var pA = results[0];
    var pB = results[1];

    var vA = pA ? findVariantBySku(pA, skuA) : null;
    var vB = pB ? findVariantBySku(pB, skuB) : null;

    var offers = [];

    if (vA) {
      offers.push({
        grade: 'A',
        variantId: vA.id,
        qty: (typeof vA.inventory_quantity === 'number') ? vA.inventory_quantity : 1,
        price: Number(vA.price || 0),
        compare_at: Number(vA.compare_at_price || 0)
      });
    }

    if (vB) {
      offers.push({
        grade: 'B',
        variantId: vB.id,
        qty: (typeof vB.inventory_quantity === 'number') ? vB.inventory_quantity : 1,
        price: Number(vB.price || 0),
        compare_at: Number(vB.compare_at_price || 0)
      });
    }

    return offers;
  }

  function setOfferCard(state, grade, offer, fullPriceCents) {
    var offersWrap = state.offersWrap;
    if (!offersWrap) return;

    var card = offersWrap.querySelector('[data-pw-offer-card="' + grade + '"]');
    if (!card) return;

    if (!offer) {
      card.hidden = true;
      return;
    }

    card.hidden = false;

    var stockEl = offersWrap.querySelector('[data-pw-offer-stock="' + grade + '"]');
    var compareEl = offersWrap.querySelector('[data-pw-offer-compare="' + grade + '"]');
    var gradedEl = offersWrap.querySelector('[data-pw-offer-graded="' + grade + '"]');
    var saveEl = offersWrap.querySelector('[data-pw-offer-save="' + grade + '"]');

    if (stockEl) stockEl.textContent = 'Only ' + (offer.qty || 1) + ' available';

    var compareCents = offer.compare_at && offer.compare_at > offer.price ? offer.compare_at : fullPriceCents;

    if (compareEl) compareEl.textContent = compareCents ? formatMoneyFromCents(compareCents) : '';
    if (gradedEl) gradedEl.textContent = offer.price ? formatMoneyFromCents(offer.price) : '';

    if (saveEl) {
      var pct = percentOff(compareCents, offer.price);
      saveEl.textContent = pct ? ('Save ' + pct) : '';
    }
  }

  async function handleSubmit(form, e) {
    var root = form.closest('.pw-prod-mock');
    if (!root) return false;

    var state = getState(root);
    if (!state) return false;

    if (!state.cfg.gradeAHandle && !state.cfg.gradeBHandle && !state.cfg.gradeCHandle) {
      return false;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    try {
      var offers = await checkOfferAll(state);
      state.offersCache = offers || [];

      if (!state.offersCache.length) {
        await addItemsToCart(buildNewItems(root, form));
        openCartDrawer();
        return true;
      }

      var fullPriceCents = await getFullPriceCents(state);

      var byA = state.offersCache.find(function (o) { return o.grade === 'A'; }) || null;
      var byB = state.offersCache.find(function (o) { return o.grade === 'B'; }) || null;

      setOfferCard(state, 'A', byA, fullPriceCents);
      setOfferCard(state, 'B', byB, fullPriceCents);
      setOffersLayout(state.offersWrap, (byA ? 1 : 0) + (byB ? 1 : 0));

      openModal(state.modal);
      return true;
    } catch (err) {
      console.error('[PW returns] error', err);
      try {
        await addItemsToCart(buildNewItems(root, form));
        openCartDrawer();
      } catch (e2) {
        console.error(e2);
      }
      return true;
    }
  }

  window.pwReturnsOfferShouldHandle = handleSubmit;

  function init(root) {
    if (!root || root.__pwReturnsInit) return;
    root.__pwReturnsInit = true;

    var form = qs(root, 'form.pw-product-form');
    var modal = qs(root, '[data-pw-returns-modal]');
    var cfgEl = qs(root, '[data-pw-returns-config]');
    var skuMapEl = qs(root, '[data-pw-variant-sku-map]');
    var offersWrap = qs(root, '[data-pw-offers-wrap]');

    if (!form || !modal || !cfgEl || !skuMapEl || !offersWrap) return;

    states.set(root, {
      root: root,
      form: form,
      modal: modal,
      cfg: safeJsonParse(cfgEl.textContent),
      skuMap: safeJsonParse(skuMapEl.textContent),
      offersWrap: offersWrap,
      offersCache: []
    });
  }

  document.addEventListener('click', function (e) {
    var modal = e.target.closest('[data-pw-returns-modal]') || document.querySelector('[data-pw-returns-modal]:not([hidden])');
    if (!modal) return;

    var root = modal.closest('.pw-prod-mock');
    var state = root ? getState(root) : null;
    if (!state) return;

    if (e.target.closest('[data-pw-returns-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closeModal(state.modal);
      return;
    }

    if (e.target.closest('[data-pw-returns-new]') || e.target.closest('[data-pw-returns-continue]')) {
      e.preventDefault();
      e.stopPropagation();

      (async function () {
        try {
          closeModal(state.modal);
          await addItemsToCart(buildNewItems(state.root, state.form));
          openCartDrawer();
        } catch (err) {
          console.error(err);
          alert("Sorry—couldn’t add to cart. Please try again.");
        }
      })();

      return;
    }

    var addBtn = e.target.closest('[data-pw-offer-add], [data-pw-returns-graded], [data-pw-returns-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();

      (async function () {
        try {
          var offer = null;

          var gradeBtn = e.target.closest('[data-pw-offer-add]');
          if (gradeBtn) {
            var grade = gradeBtn.getAttribute('data-pw-offer-add');
            offer = (state.offersCache || []).find(function (o) { return o.grade === grade; }) || null;
          } else {
            offer = bestOffer(state.offersCache || []);
          }

          if (!offer) return;

          closeModal(state.modal);
          await addItemsToCart(buildGradedItems(state.root, state.form, offer.variantId));
          openCartDrawer();
        } catch (err) {
          console.error(err);
          alert("Sorry—couldn’t add to cart. Please try again.");
        }
      })();

      return;
    }
  }, true);

  function boot() {
    document.querySelectorAll('.pw-prod-mock').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();